if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InnerBlocks,
    } = window.wp.editor;

    registerBlockType('custom-gutenberg/container', {
        // built-in attributes
        title: 'Container',
        description: 'Custom Container',
        icon: '',
        category: 'custom-containers',
        example: {},

        // built-in functions
        edit() {

            return (
                <div className="container">
                    <InnerBlocks />
                </div>
            );
        },

        save() {

            return (
                <div className="container">
                    <InnerBlocks.Content />
                </div>
            );
        },
    });
}